import styled from 'styled-components';
import { NumberTicket } from '../../../ticket/NumberTicket';
import { TicketWithUsedButton } from '../TicketWithUsedButton';
import { useTextVariant } from '../../../../hook/useTextVariant';
import { MAIN_EVENT_CONSTANTS, getWelcomeText } from '../../../../constants/mainEvent';
import { MainEventViewProps } from '../MainEvent';

export const MainEventPc = ({
  goOfflineTab,
  ticketsToRender,
  totalCount,
  usedCount,
  ticketUseYn,
}: MainEventViewProps) => {
  const { getText } = useTextVariant(MAIN_EVENT_CONSTANTS, false);

  return (
    <>
      <WelcomeTextContainer>
        <WelcomeText>{getWelcomeText(totalCount, usedCount)}</WelcomeText>
      </WelcomeTextContainer>
      <BottomInfoContainer>
        {ticketsToRender.map((cnt) => {
          if (ticketUseYn === 'Y')
            return (
              <TicketWithUsedButton
                key={cnt.ticketNo}
                ticketNumber={cnt.ticketNo}
                isUsed={cnt.usedYn}
              />
            );

          return <NumberTicket key={cnt.ticketNo} cnt={cnt.ticketNo} />;
        })}

        <TicketDetailContainer>
          <TicketDetailText>{getText('ticketDetail')}</TicketDetailText>
        </TicketDetailContainer>
      </BottomInfoContainer>

      <BottomTabContainer>
        <GoOfflineEventDetailBtn onClick={goOfflineTab}>
          {getText('btnText')}
        </GoOfflineEventDetailBtn>
      </BottomTabContainer>
    </>
  );
};

const WelcomeText = styled.h4`
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: -0.88px;

  span {
    font-weight: 700;
  }
`;

const WelcomeTextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
`;

const BottomInfoContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  padding-left: 20px;
  padding-right: 20px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 130px;
`;

const BottomTabContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #262524;
  height: 96px;
`;

const GoOfflineEventDetailBtn = styled.button`
  width: 442px;
  height: 70px;
  font-weight: 700;
  font-size: 24px;
  line-height: 70px;
  letter-spacing: -0.04em;
  color: #ffffff;
  border-radius: 125px;
  background: var(
    --Style,
    linear-gradient(90deg, rgba(25, 36, 255, 0.85) 39.5%, rgba(77, 14, 166, 0.85) 100%)
  );
  backdrop-filter: blur(25px);
  margin-right: 20px;
  cursor: pointer;
`;

const TicketDetailContainer = styled.ul`
  padding-left: 10px;
  margin: 0;
`;

const TicketDetailText = styled.li`
  font-weight: 500;
  letter-spacing: -0.04em;
  color: #939393;
  font-size: 16px;
  line-height: 24px;
`;
